import { ChangeDetectionStrategy, Component, OnDestroy, OnInit } from '@angular/core';
import { MsalService } from '@azure/msal-angular';
import { Subject, takeUntil } from 'rxjs';

@Component({
  selector: 'app-redirect',
  template: '',
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class AuthenticationRedirectComponent implements OnInit, OnDestroy {
  private readonly destroying$ = new Subject<void>();

  constructor(private authService: MsalService) {}

  ngOnInit(): void {
    this.authService.handleRedirectObservable()
      .pipe(takeUntil(this.destroying$))
      .subscribe({
        error: () => {
          // MSAL also publishes ACQUIRE_TOKEN_FAILURE. AppComponent uses that
          // event to render a retry state, while this handler prevents an
          // unhandled observable error from escaping into the browser.
        }
      });
  }

  ngOnDestroy(): void {
    this.destroying$.next();
    this.destroying$.complete();
  }
}
